import { Endpoint } from "../config";

export type UserEndpointType =
  | "userByID"
  | "staffList"
  | "staffStatusToggle"
  | "staffAdd"
  | "updateProfilePicture"
  | "updateBlockedStatus"
  | "usersList"
  | "userList"
  | "onboardedUsers"
  | "invitedUsers"
  | "editProfileRequests"
  | "userAssignedProfile"
  | "inviteUser"
  | "userProfileApprovalStatus"
  | "dashboardStatus"
  | "invitationResend"
  | "userProfileDetail"
  | "updateAccount"
  | "updateAccountRequest"
  | "userTypeList"
  | "sendOTP";

export const userEndpoints: Record<UserEndpointType, Endpoint> = {
  userByID: {
    url: "users",
  },
  staffList: {
    url: "staff/list/",
  },
  staffStatusToggle: {
    url: "staff/status-toggle/",
  },
  staffAdd: {
    url: "staff/create/",
  },
  updateProfilePicture: {
    url: "update-profile-picture/",
  },
  updateBlockedStatus: {
    url: "update-blocked-status/",
  },
  usersList: {
    url: "users/",
  },
  userList: {
    url: "user-list",
  },
  onboardedUsers: {
    url: "user-detail/",
  },
  invitedUsers: {
    url: "users/invited/",
  },
  editProfileRequests: {
    url: "users/profile-update/",
  },
  userAssignedProfile: {
    url: "users/assign-profile",
  },
  inviteUser: {
    url: "invitation/sign-up/",
  },
  userProfileApprovalStatus: {
    url: "update-approval-status/",
  },
  dashboardStatus: {
    url: "user/status/",
  },
  invitationResend: {
    url: "sign-up-resend-invitation/",
  },
  userProfileDetail: {
    url: "user-detail/",
  },
  updateAccount: {
    url: "update-account-details/",
  },
  updateAccountRequest: {
    url: "update-account-details-request/",
  },
  userTypeList: {
    url: "user-type-list/",
  },
  sendOTP: {
    url: "send-otp/",
  },
};
